import { Gallery } from "react-photoswipe-gallery";
import ThreadGalleryItem from "./ThreadGalleryItem";

interface IThreadGallery {
  documents?: any;
  isPrivate?: boolean;
  onRemoveFile?: any;
  editMode?: boolean;
  small?: boolean;
}
function ThreadGallery({
  documents,
  isPrivate,
  onRemoveFile,
  editMode,
  small = false,
}: IThreadGallery) {
  const containerStyle = isPrivate ? "flex gap-1" : "flex gap-1 justify-end";
  const list = (documents || []).map((file: any) => (
    <ThreadGalleryItem
      file={file}
      onRemoveFile={() => onRemoveFile(file)}
      editMode={editMode}
      small={small}
    />
  ));

  if (!documents || documents.length < 1) {
    return null;
  }
  return (
    <Gallery withDownloadButton>
      <div className={containerStyle}>{list}</div>
    </Gallery>
  );
}

export default ThreadGallery;
